<template>
  <div>
    <learning-programs />
  </div>
</template>

<script>
import LearningPrograms from '@/gen-2/pages/LearningPrograms.vue'
export default {
  components: {
    LearningPrograms
  },
  data() {
    return {
      
    };
  },
  methods: {
    
  },
  created() {
    
  },
  mounted() {
    
  }
};
</script>
<style lang="scss">
</style>
